import { isBrowser } from "@react-hookz/web/cjs/util/const";

let audio: HTMLAudioElement | null = null;

// This needs to be played whenever a WebAudio track is played.
// It is a hack that will force Safari to unmute the audio context when the user's phone mute switch is on.
// Without it the audio will be muted unles the switch is off
export function playSilentAudio() {
  if (!isBrowser) {
    return;
  }

  if (!audio) {
    audio = document.createElement("audio");
    audio.setAttribute("x-webkit-airplay", "deny"); // Disable the iOS control center media widget
    audio.preload = "auto";
    audio.loop = true;
    audio.src = "/audio/silent-audio.mp3";
    audio.load();
  }

  audio.play();
}
